import { useState } from 'react';

import { KycFlow } from '#src/components/kyc/KycFlow/index.tsx';

import { AccountVerificationContext } from './AccountVerification/AccountVerificationContext.tsx';
import { IdentityVerificationCTA } from './AccountVerification/IdentityVerificationCTA/index.tsx';

type Props = {
  onDone: () => void;
};

export const JonumKycPromptView = ({ onDone }: Props) => {
  const [showKycFlow, setShowKycFlow] = useState(false);

  if (showKycFlow) {
    return <KycFlow onDone={onDone} />;
  }

  return (
    <AccountVerificationContext.Provider
      value={{ onSkip: onDone, updateData: () => {}, loading: false }}
    >
      <IdentityVerificationCTA onNext={() => setShowKycFlow(true)} />
    </AccountVerificationContext.Provider>
  );
};
